import { ActionTypes, ReduxAction } from './types';
import { Dispatch } from 'redux';

export const setActiveTab =
  (value: string) => async (dispatch: Dispatch<ReduxAction>) => {
    dispatch({
      type: ActionTypes.SET_ACTIVE_TAB,
      payload: value,
    });
  };
